// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"AdminAnnouncementsScreen_contentWrapper__1d1Eu","styleBadge":"AdminAnnouncementsScreen_styleBadge__1pMr5"};